<template>
    <!-- Page header -->
    <div>
        <div class="page-header page-header-light">
            <div class="page-header-content header-elements-md-inline">
                <div class="page-title d-flex">
                    <h4><span class="font-weight-semibold">Settings - Godaddy & Sendgrid accounts</span></h4>
                    <a href="#" class="header-elements-toggle text-default d-md-none"><i class="icon-more"></i></a>
                </div>
            </div>
        </div>
        <!-- /page header -->
        <!-- Content area -->
        <div class="content">
            <div class="card">
                <h1 style="padding:10px">Godaddy accounts <button class="btn btn-primary"
                        @click="adding_godaddy = true">Add</button></h1>
                <div class="table-responsive" :class="{ 'loading-mask': godaddy_loading }">
                    <!--  <div class="table-loader" v-if="loading">
                        <i class="icon-spinner2 spinner" />
                    </div> -->
                    <table class="table table-striped table-xs">
                        <thead>
                            <tr>
                                <th>No.</th>
                                <th>Name</th>
                                <th>Api key</th>
                                <th>Api secret</th>
                                <th>Created at</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="r, k in godaddy_acc">
                                <td style="width:10px">{{ k + 1 }}</td>
                                <td>{{ r.name }}</td>
                                <td>{{ r.api_key }}</td>
                                <td>{{ r.api_secret }}</td>
                                <td>{{ r.created_at | formatDate }}</td>
                                <td><button class="btn btn-danger"
                                        @click="remove($event, 'godaddy', r._id)">Remove</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="card">
                <h1 style="padding:10px">Sendgrid accounts <button class="btn btn-primary"
                        @click="adding_sendgrid = true">Add</button></h1>
                <div class="table-responsive" :class="{ 'loading-mask': sendgrid_loading }">
                    <!--  <div class="table-loader" v-if="loading">
                        <i class="icon-spinner2 spinner" />
                    </div> -->
                    <table class="table table-striped table-xs">
                        <thead>
                            <tr>
                                <th>No.</th>
                                <th>Name</th>
                                <th>Api key</th>
                                <th>IP address</th>
                                <th>Webhook domain</th>
                                <th>Registered webhook domain</th>
                                <th>Status</th>
                                <th>Status last changed at</th>
                                <th>Created at</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="r, k in sendgrid_acc">
                                <td style="width:10px">{{ k + 1 }}</td>
                                <td>{{ r.name }}</td>
                                <td>{{ r.api_key }}</td>
                                <td>{{ r.use_ip }}</td>
                                <td>{{ r.webhook_domain || 'n/a' }}</td>
                                <td>{{ r.registered_webhook_domain || 'n/a' }}</td>
                                <td>
                                    <i v-if="r.status_message" class="icon-info22"></i>
                                    <template v-if="r.status_message">{{ r.status_message }}</template>
                                    <span class="badge" :class="{
                                        'badge-slate': r.status === 'new',
                                        'badge-success': r.status === 'live',
                                        'badge-warning': r.status === 'pause',
                                        'badge-danger': r.status === 'error',
                                    }">
                                        {{ r.status }}
                                    </span>
                                </td>
                                <td v-if="r.status_last_change">{{ r.status_last_change | formatDate }}</td>
                                <td v-else></td>
                                <td>{{ r.created_at | formatDate }}</td>
                                <td>

                                    <button class="btn btn-primary" @click="registerWebhook($event, r._id)">Register
                                        webhook</button>
                                    <button class="btn btn-primary" @click="showWebhook($event, r._id)">Get
                                        webhook</button>
                                    <button class="btn btn-primary" @click="testIp($event, r._id, 'sendgrid')">Test
                                        IP</button>

                                    <button class="btn btn-primary" @click="adding_sendgrid = r">Edit</button>
                                    <button class="btn btn-danger"
                                        @click="remove($event, 'sendgrid', r._id)">Remove</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="card">
                <h1 style="padding:10px">Mailgun accounts <button class="btn btn-primary"
                        @click="adding_mailgun = true">Add</button></h1>
                <div class="table-responsive" :class="{ 'loading-mask': mailgun_loading }">
                    <!--  <div class="table-loader" v-if="loading">
                        <i class="icon-spinner2 spinner" />
                    </div> -->
                    <table class="table table-striped table-xs">
                        <thead>
                            <tr>
                                <th>No.</th>
                                <th>Name</th>
                                <th>Api key</th>
                                <th>IP address</th>
                                <th>Created at</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="r, k in mailgun_acc">
                                <td style="width:10px">{{ k + 1 }}</td>
                                <td>{{ r.name }}</td>
                                <td>{{ r.api_key }}</td>
                                <td>{{ r.use_ip }}</td>
                                <td>{{ r.created_at | formatDate }}</td>
                                <td>
                                    <button class="btn btn-primary" @click="testIp($event, r._id, 'mailgun')">Test
                                        IP</button>
                                    <button class="btn btn-primary" @click="adding_mailgun = r">Edit</button>
                                    <button class="btn btn-danger"
                                        @click="remove($event, 'mailgun', r._id)">Remove</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="card">
                <h1 style="padding:10px">Vultr accounts <button class="btn btn-primary"
                        @click="adding_vultr = true">Add</button>
                </h1>
                <div class="table-responsive" :class="{ 'loading-mask': vultr_loading }">
                    <!--  <div class="table-loader" v-if="loading">
                        <i class="icon-spinner2 spinner" />
                    </div> -->
                    <table class="table table-striped table-xs">
                        <thead>
                            <tr>
                                <th>No.</th>
                                <th>Name</th>
                                <th>Api key</th>
                                <th>Created at</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="r, k in vultr_acc">
                                <td style="width:10px">{{ k + 1 }}</td>
                                <td>{{ r.name }}</td>
                                <td>{{ r.api_key }}</td>
                                <td>{{ r.created_at | formatDate }}</td>
                                <td>
                                    <button class="btn btn-primary" @click="adding_vultr = r">Edit</button>
                                    <button class="btn btn-danger"
                                        @click="remove($event, 'vultr', r._id)">Remove</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="card">
                <h1 style="padding:10px">AWS accounts <button class="btn btn-primary"
                        @click="adding_aws = true">Add</button></h1>
                <div class="table-responsive" :class="{ 'loading-mask': aws_loading }">
                    <!--  <div class="table-loader" v-if="loading">
                        <i class="icon-spinner2 spinner" />
                    </div> -->
                    <table class="table table-striped table-xs">
                        <thead>
                            <tr>
                                <th>No.</th>
                                <th>Name</th>
                                <!-- <th>Api key</th> -->
                                <!-- <th>Api secret</th> -->
                                <th>Rate limit (per second)</th>
                                <th>Sending limit per 24h</th>
                                <th>Send in last 24h</th>
                                <th>Manual limit 24h</th>
                                <th>Auto resume (for manual limit)</th>
                                <th>AWS region</th>
                                <th>IP address</th>
                                <th>Setup completed</th>
                                <th>Status</th>
                                <th>Created at</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="r, k in aws_acc">
                                <td style="width:10px">{{ k + 1 }}</td>
                                <td>{{ r.name }}</td>
                                <!-- <td>{{ r.api_key }}</td> -->
                                <!-- <td>{{ r.api_secret.substr(0, 5) }}...</td> -->
                                <td>{{ r.limit_per_second }}</td>
                                <td>{{ r.limit_per_24h }}</td>
                                <td>{{ r.limit_current_usage }}</td>
                                <td>{{ r.manual_limit_per_24h }}</td>
                                <td>{{ r.manual_limit_resume_quota }}</td>
                                <td>{{ r.aws_region }}</td>
                                <td>{{ r.use_ip }}</td>
                                <td><span class="badge"
                                        :class="{ 'badge-success': r.aws_setup_completed, 'badge-danger': !r.aws_setup_completed }">
                                        {{ r.aws_setup_completed ? 'COMPLETED' : 'PENDING' }}
                                    </span></td>
                                <td>
                                    <i v-if="r.status_message" class="icon-info22"></i>
                                    <template v-if="r.status_message">{{ r.status_message }}</template>
                                    <span class="badge" :class="{
                                        'badge-slate': r.status === 'new',
                                        'badge-success': r.status === 'live',
                                        'badge-warning': r.status === 'pause',
                                        'badge-danger': r.status === 'error',
                                    }">
                                        {{ r.status }}
                                    </span>
                                </td>
                                <td>{{ r.created_at | formatDate }}</td>
                                <td>

                                    <button class="btn btn-primary" @click="showWebhook($event, r._id)">Get
                                        webhook</button>
                                    <button class="btn btn-primary" @click="testIp($event, r._id, 'aws')">Test
                                        IP/access</button>

                                    <button class="btn btn-primary" @click="adding_aws = r">Edit</button>
                                    <button class="btn btn-success" v-if="r.status != 'live'"
                                        @click="accountSetStatus($event, r._id, 'live')">Go
                                        live</button>
                                    <button class="btn btn-slate" v-if="r.status != 'pause' && r.status != 'error'"
                                        @click="accountSetStatus($event, r._id, 'pause')">Pause</button>
                                    <button class="btn btn-danger" @click="remove($event, 'aws', r._id)">Remove</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="card content">
                <h1>Default throttle</h1>
                <p>A default throttle (number of message sent per hour per campaign) value that will be set to all
                    created
                    campaign if you will not fill it manually</p>
                <fieldset class="mb-3" :class="{ 'loading-mask': loading }">
                    <div class="form-group row">
                        <label class="col-form-label col-lg-2">Throttle value</label>
                        <div class="col-lg-4">
                            <input type="number" min="0" placeholder="throttle value (number)" class="form-control"
                                v-model="form.throttle">
                        </div>
                    </div>
                </fieldset>
                <div class="form-group row">
                    <label class="col-form-label col-lg-12">
                        <button type="button" class="btn btn-primary" @click="saveDefaultThrottle()">Save</button>
                    </label>
                </div>
            </div>
            <div class="card content">
                <h1>Default A record</h1>
                <p>A default DNS A record value (ip address) that will be added to DOMAIN (not subdomain because A
                    record is
                    occupied by CNAME records) upon adding (if empty then the record will not be added)</p>
                <fieldset class="mb-3" :class="{ 'loading-mask': loading }">
                    <div class="form-group row">
                        <label class="col-form-label col-lg-2">Record A value</label>
                        <div class="col-lg-4">
                            <input type="text" placeholder="ip address" class="form-control" v-model="form.record">
                        </div>
                    </div>
                </fieldset>
                <div class="form-group row">
                    <label class="col-form-label col-lg-12">
                        <button type="button" class="btn btn-primary" @click="saveDefaultRecord()">Save</button>
                    </label>
                </div>
            </div>
            <div class="card content">
                <h1>Default MX records</h1>
                <p>A default DNS MX record values (domain) that will be added to top level domain (@) upon adding
                    subdomain
                    (if empty then the record will not be added)</p>
                <h2>Saved records</h2>
                <ul>
                    <li v-for="v, k in default_mx_records">
                        {{ v.mixed_value.value }} (priority: {{ v.mixed_value.priority }})
                        <span style="color:red; text-decoration: underline; cursor: pointer"
                            @click="removeDefaultMXRecord($event, v._id)">Remove</span>
                    </li>
                    <li v-if="default_mx_records.length === 0">
                        This list seems to be empty
                    </li>
                </ul>
                <fieldset class="mb-3" :class="{ 'loading-mask': loading }">
                    <div class="form-group row">
                        <label class="col-form-label col-lg-2">Record MX value</label>
                        <div class="col-lg-4">
                            <input type="text" placeholder="(sub)domain" class="form-control" v-model="form.record_mx">
                        </div>
                        <div class="col-lg-4">
                            <input type="number" placeholder="priority" class="form-control"
                                v-model="form.record_mx_priority">
                        </div>
                    </div>
                </fieldset>
                <div class="form-group row">
                    <label class="col-form-label col-lg-12">
                        <button type="button" class="btn btn-primary" @click="saveDefaultMXRecord()">Save</button>
                    </label>
                </div>
            </div>
            <div class="card content">
                <h1>Default subdomains</h1>
                <p>A list of subdomains that will be automatically added upon adding new domain</p>
                <fieldset class="mb-3" :class="{ 'loading-mask': loading }">
                    <div class="form-group row">
                        <label class="col-form-label col-lg-2">Subdomain</label>
                        <div class="col-lg-4">
                            <input @keyup.enter="saveSubdomains()" type="text" placeholder="type here"
                                class="form-control" v-model="form.subdomain">
                        </div>
                    </div>
                </fieldset>
                <div class="form-group row">
                    <label class="col-form-label col-lg-12">
                        <button type="button" class="btn btn-primary" @click="saveSubdomains()">Add</button>
                    </label>
                </div>
                <h2>Saved subdomains</h2>
                <ul>
                    <li v-for="v, k in default_subdomains">
                        {{ v.value }}
                        <span style="color:red; text-decoration: underline; cursor: pointer"
                            @click="removeSubdomain($event, k)">Remove</span>
                    </li>
                </ul>
            </div>

            <div class="card content">
                <h1>Default names</h1>
                <p>A list of names that will be randomly filled in a campaign (name and user part as: <<strong>
                        name</strong>> <strong>address</strong>@domain.com)</p>

                <template v-for="v, k in default_names">
                    <hr v-if="k > 0 && default_names[k - 1].mixed_value.group != v.mixed_value.group" />
                    <h4 v-if="k === 0 || k > 0 && default_names[k - 1].mixed_value.group != v.mixed_value.group">Group:
                        {{ v.mixed_value.group }}</h4>
                    <p>
                        name: {{ v.mixed_value.name }} address: {{ v.mixed_value.address }}
                        <span style="color:red; text-decoration: underline; cursor: pointer"
                            @click="removeDefaultName($event, v._id)">Remove</span>
                    </p>
                </template>
                <hr />
                <h4>Add new</h4>
                <fieldset class="mb-3" :class="{ 'loading-mask': loading }">
                    <div class="form-group row">
                        <label class="col-form-label col-lg-2">Values</label>
                        <div class="col-lg-3">
                            <input type="text" placeholder="group, like: Joe's" class="form-control"
                                v-model="form.default_group">
                        </div>
                        <div class="col-lg-3">
                            <input type="text" placeholder="name, like: John Doe" class="form-control"
                                v-model="form.default_name">
                        </div>
                        <div class="col-lg-3">
                            <input type="text" placeholder="address, like: john.doe" class="form-control"
                                v-model="form.default_address">
                        </div>
                    </div>
                </fieldset>
                <div class="form-group row">
                    <label class="col-form-label col-lg-12">
                        <button type="button" class="btn btn-primary" @click="saveDefaultName()">Save</button>
                    </label>
                </div>
            </div>

            <div class="card content">
                <h1>Campaign tags</h1>
                <p>Tags you can add to each campaign</p>
                <fieldset class="mb-3" :class="{ 'loading-mask': loading }">
                    <div class="form-group row">
                        <label class="col-form-label col-lg-2">Tag</label>
                        <div class="col-lg-4">
                            <input @keyup.enter="saveCampaignTag()" type="text" placeholder="type here"
                                class="form-control" v-model="form.campaign_tag">
                        </div>
                    </div>
                </fieldset>
                <div class="form-group row">
                    <label class="col-form-label col-lg-12">
                        <button type="button" class="btn btn-primary" @click="saveCampaignTag()">Add</button>
                    </label>
                </div>
                <h2>Saved tags</h2>
                <ul>
                    <li v-for="v, k in campaign_tags">
                        {{ v.value }}
                        <span style="color:red; text-decoration: underline; cursor: pointer"
                            @click="removeCampaignTag($event, v._id)">Remove</span>
                    </li>
                </ul>
            </div>

            <div class="card content">
                <h1>Contact list tags</h1>
                <p>Tags you can add to each campaign</p>
                <fieldset class="mb-3" :class="{ 'loading-mask': loading }">
                    <div class="form-group row">
                        <label class="col-form-label col-lg-2">Tag</label>
                        <div class="col-lg-4">
                            <input @keyup.enter="saveContactListTag()" type="text" placeholder="type here"
                                class="form-control" v-model="form.contact_list_tag">
                        </div>
                    </div>
                </fieldset>
                <div class="form-group row">
                    <label class="col-form-label col-lg-12">
                        <button type="button" class="btn btn-primary" @click="saveContactListTag()">Add</button>
                    </label>
                </div>
                <h2>Saved tags</h2>
                <ul>
                    <li v-for="v, k in contact_list_tags">
                        {{ v.value }}
                        <span style="color:red; text-decoration: underline; cursor: pointer"
                            @click="removeContactListTag($event, v._id)">Remove</span>
                    </li>
                </ul>
            </div>

        </div>
        <!-- /content area -->
        <godaddy v-if="adding_godaddy" @close="adding_godaddy = false" @reload="load()" />
        <sendgrid v-if="adding_sendgrid" :obj="adding_sendgrid" @close="adding_sendgrid = false"
            :domains="webhook_domains" @reload="load()" />
        <mailgun v-if="adding_mailgun" :obj="adding_mailgun" @close="adding_mailgun = false"
            :domains="webhook_domains || []" @reload="load()" />
        <aws v-if="adding_aws" :obj="adding_aws" @close="adding_aws = false; load()" :domains="webhook_domains"
            @reload="load()" />
        <vultr v-if="adding_vultr" :obj="adding_vultr" @close="adding_vultr = false; load()" @reload="load()" />
        <!-- /content area -->
    </div>
</template>
<script>
import moment from 'moment'
import EventBus from '@/event_bus'
import Godaddy from './modal/Godaddy.vue'
import Sendgrid from './modal/Sendgrid.vue'
import Mailgun from './modal/Mailgun.vue'
import Aws from './modal/Aws.vue'
import Vultr from './modal/Vultr.vue'
export default {
    components: { Godaddy, Sendgrid, Aws, Mailgun, Vultr },
    data() {
        return {
            godaddy_acc: [],
            sendgrid_acc: [],
            mailgun_acc: [],
            aws_acc: [],
            vultr_acc: [],
            godaddy_loading: true,
            loading: false,

            sendgrid_loading: true,
            mailgun_loading: true,
            aws_loading: true,
            vultr_loading: true,

            adding_godaddy: false,
            adding_sendgrid: false,
            adding_mailgun: false,
            adding_aws: false,
            adding_vultr: false,

            form: {
                throttle: null,
                record: null,
                record_mx: null,
                record_mx_priority: null,
                subdomain: null,

                default_name: null,
                default_address: null,
                deafult_group: null,
                campaign_tag: null,
                contact_list_tag: null
            },

            default_subdomains: [],
            default_mx_records: [],
            default_names: [],
            webhook_domains: [],
            campaign_tags: [],
            contact_list_tags: []
        }
    },
    watch: {

    },
    computed: {

    },
    methods: {
        accountSetStatus(_, id, status) {
            this.$api.postReq('settings/account/' + id + '/status', { status: status }).then(res => {
                this.$notify.addSuccess('Status has been updated, check `status` column')
                this.load()
            }).catch(err => {
                this.load()
            })
        },
        showWebhook(_, id) {
            this.$api.getReq('settings/account/' + id + '/webhook').then(res => {
                this.$notify.addSuccess(res.body.result, 7000)
            }).catch(err => {
                this.$notify.addError("Error while retreiving webhook: " + err.data.error)
            })
        },
        testIp(_, id, provider) {
            this.$api.postReq('settings/account/test_ip_access/' + id, { provider: provider }).then(res => {
                if (res.body.response) {
                    this.$notify.addSuccess("Used IP: " + (res.body.response.body && res.body.response.body.ip))
                } else {
                    this.$notify.addSuccess("Used IP: OK")
                }
            }).catch(err => {
                if (err.body) {
                    this.$notify.addError("Error while testing IP: " + JSON.stringify(err.body.response))
                } else {
                    this.$notify.addError("Error while testing IP: " + JSON.stringify(err))
                }
            })
        },
        registerWebhook(_, id) {
            this.$api.postReq("settings/account/" + id + "/webhook").then(res => {
                this.$notify.addSuccess('Webhook registered')
            }).catch(err => {
                this.$notify.addError('Error while adding webhook: ' + err.data.error)
            })
        },

        saveDefaultName() {
            this.$api.postReq("settings/default_name", {
                name: this.form.default_name,
                address: this.form.default_address,
                group: this.form.default_group
            }).then(res => {
                this.form.default_name = ''
                this.form.default_address = ''
                this.form.default_group = ''
                this.$notify.addSuccess('Default name saved')
                this.load()
            })
        },
        removeDefaultName(_, id) {
            this.$confirm({ message: 'Are you sure?' }).then(() => {
                this.$api.deleteReq("settings/default_name?id=" + id).then(res => {
                    this.$notify.addSuccess('Name removed')
                    this.load()
                })
            })
        },

        saveDefaultMXRecord() {
            this.$api.postReq("settings/default_mx_record", {
                value: this.form.record_mx,
                priority: this.form.record_mx_priority,
            }).then(res => {
                this.$notify.addSuccess('Default record saved')
                this.load()
            })
        },
        saveDefaultThrottle() {
            this.$api.postReq("settings/default_throttle", {
                value: this.form.throttle,
            }).then(res => {
                this.$notify.addSuccess('Default throttle saved')
                this.load()
            })
        },
        removeDefaultMXRecord(_, id) {
            this.$confirm({ message: 'Are you sure?' }).then(() => {
                this.$api.deleteReq("settings/default_mx_record?id=" + id).then(res => {
                    this.$notify.addSuccess('Record removed')
                    this.load()
                })
            })
        },
        removeSubdomain(_, k) {
            this.$confirm({ message: 'Are you sure?' }).then(() => {
                if (this.default_subdomains.length == 1) {
                    this.default_subdomains = []
                } else {
                    this.default_subdomains.splice(k, 1)
                }
                this.saveSubdomains()
            })
        },
        removeCampaignTag(_, id) {
            this.$confirm({ message: 'Are you sure?' }).then(() => {
                this.$api.deleteReq('settings/tags/campaign?id=' + id).then(() => {
                    this.load()
                })
            })
        },
        saveCampaignTag() {
            this.$api.postReq("settings/tags/campaign", {
                name: this.form.campaign_tag
            }).then(res => {
                this.$notify.addSuccess('Default record saved')
                this.form.campaign_tag = null
                this.load()
            })
        },
        removeContactListTag(_, id) {
            this.$confirm({ message: 'Are you sure?' }).then(() => {
                this.$api.deleteReq('settings/tags/contact_list?id=' + id).then(() => {
                    this.load()
                })
            })
        },
        saveContactListTag() {
            this.$api.postReq("settings/tags/contact_list", {
                name: this.form.contact_list_tag
            }).then(res => {
                this.$notify.addSuccess('Default record saved')
                this.form.contact_list_tag = null
                this.load()
            })
        },
        saveDefaultRecord() {
            this.$api.postReq("settings/default_a_record", {
                value: this.form.record
            }).then(res => {
                this.$notify.addSuccess('Default record saved')
            })
        },
        saveSubdomains() {
            if (this.form.subdomain) {
                this.default_subdomains.push({ value: this.form.subdomain })
            }

            this.$api.postReq("settings/default_subdomains", {
                value: this.default_subdomains
            }).then(res => {
                this.form.subdomain = null
                this.$notify.addSuccess('Subdomain saved')
            })
        },
        remove(_, type, id) {
            this.$confirm({ message: 'Are you sure?' }).then(() => {
                this.$api.deleteReq('accounts/' + type + '?id=' + id).then(() => {
                    this.load()
                })
            })
        },
        load(showloader, changePage, refreshProfile) {
            this.godaddy_loading = true
            this.sendgrid_loading = true
            this.aws_loading = true
            this.$api.getReq('accounts/godaddy').then(res => {
                this.godaddy_acc = res.body.data
                this.godaddy_loading = false
            })

            this.$api.getReq('accounts/sendgrid').then(res => {
                this.sendgrid_acc = res.body.data
                this.sendgrid_loading = false
            })

            this.$api.getReq('accounts/aws').then(res => {
                this.aws_acc = res.body.data
                this.aws_loading = false
            })

            this.$api.getReq('accounts/mailgun').then(res => {
                this.mailgun_acc = res.body.data
                this.mailgun_loading = false
            })

            this.$api.getReq('accounts/vultr').then(res => {
                this.vultr_acc = res.body.data
                this.vultr_loading = false
            })

            this.loading = true
            this.$api.getReq('settings').then(res => {
                this.form.record = res.body.data.default_a_record
                this.form.throttle = res.body.data.default_throttle
                this.default_mx_records = res.body.data.default_mx_records || []
                this.default_subdomains = res.body.data.default_subdomains || []
                this.default_names = res.body.data.default_names || []
                this.webhook_domains = res.body.data.webhook_domains || []
                this.default_names = this.default_names.sort((a, b) => {
                    return a.mixed_value.group > b.mixed_value.group ? 1 : -1
                })
                this.campaign_tags = res.body.data.campaign_tags
                this.contact_list_tags = res.body.data.contact_list_tags

                this.loading = false
            })
        }
    },
    destroyed() { },
    mounted() {
        this.load()
    }
}
</script>
<style>
.avsquare {
    width: 7px;
    height: 100%;
    float: left;
    cursor: pointer;
    border-left: 1px solid rgba(0, 0, 0, .1);
}

.avsquare:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

.avsquare:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

tbody .btn {
    padding: 3px 11px;
}
</style>


// WEBPACK FOOTER //
// src/components/Settings.vue